/* unplugin-vue-components disabled */import script from "./BatchAddControlSalesTeamModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BatchAddControlSalesTeamModal.vue?vue&type=script&setup=true&lang=js"

import "./BatchAddControlSalesTeamModal.vue?vue&type=style&index=0&id=7a372c4f&lang=scss"

const __exports__ = script;

export default __exports__